// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyA64BF5SNyIK9PuufqmCFLHeoozxHH34Qo",
  authDomain: "crowd-call.firebaseapp.com",
  projectId: "crowd-call",
  storageBucket: "crowd-call.appspot.com",
  messagingSenderId: "862097352426",
  appId: "1:862097352426:web:344cc59f49c8a0dfca9993",
  measurementId: "G-ZNG42NPXMC"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);